import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { AuthService, ConfigStateService } from '@abp/ng.core';

@Component({
  selector: 'app-header-user',
  standalone: true,
  imports: [CommonModule, AvatarModule, MenuModule, TooltipModule],
  template: `
    <div class="user-menu">
      <ng-container *ngIf="isLoggedIn()">
        <p-menu #menu [model]="items" [popup]="true" />
        <div class="user-profile" (click)="menu.toggle($event)" [pTooltip]="userName()" tooltipPosition="bottom" showDelay="1000" hideDelay="300" [attr.data-username]="userName()">
          <p-avatar *ngIf="userAvatar(); else nameAvatar" [image]="userAvatar()" shape="circle" size="normal" [style]="{ cursor: 'pointer' }" />
          <ng-template #nameAvatar>
            <p-avatar
              [label]="getInitials(userName())"
              shape="circle"
              size="normal"
              [style]="{
                'background-color': '#ece9fc',
                color: '#204496',
                cursor: 'pointer'
              }"
            />
          </ng-template>
          <i class="pi pi-angle-down"></i>
        </div>
      </ng-container>
    </div>
  `,
  styleUrl: './user-menu.component.scss',
})
export class UserMenuComponent {
  constructor(private readonly authService: AuthService, private readonly config: ConfigStateService) {}

  items: MenuItem[] = [
    {
      label: 'Sign Out',
      icon: 'pi pi-sign-out',
      command: () => this.logout(),
    },
  ];

  userName(): string {
    const currentUser = this.config.getOne('currentUser');
    return currentUser.userName!;
  }

  userAvatar(): string {
    return '';
  }

  login() {
    this.authService.navigateToLogin();
  }

  logout() {
    this.authService.logout();
  }

  isLoggedIn(): boolean {
    return this.authService.isAuthenticated;
  }

  getInitials(name: string): string {
    return name
      .split(' ')
      .map((word) => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 1);
  }
}
